import apiClient from './apiClient';

export async function getOrderBasedPlanWithPrediction(period = 'weekly') {
  const res = await apiClient.get('/production-planning/order-based-plan-with-prediction', { params: { period } });
  return res.data.data.items;
}
export async function listSizes() {
  const res = await apiClient.get('/production-planning/sizes');
  return res.data.data.items;
}
export async function getCalendar(pastDays = 60) {
  const res = await apiClient.get('/production-planning/calendar', { params: { pastDays } });
  return res.data.data.items;
}
export async function refreshPlan() {
  const res = await apiClient.post('/production-planning/refresh');
  return res.data.data;
}

export async function getSalesBasedPlan({ days = 30, sizeId = '', boxes = 0 } = {}) {
  const params = { days };
  if (sizeId !== '' && sizeId !== null && sizeId !== undefined) params.sizeId = sizeId;
  if (boxes > 0) params.boxes = boxes;
  const res = await apiClient.get('/production-planning/sales-based-plan', { params });
  return res.data.data;
}

export async function getProductionCalendar(pastDays = 60) {
  const res = await apiClient.get('/production-planning/production-calendar', { params: { pastDays } });
  return res.data.data.items;
}

export async function getProductionDay(date) {
  const res = await apiClient.get('/production-planning/production-day', { params: { date } });
  return res.data.data;
}

export async function getProductionHold() {
  const res = await apiClient.get('/production-planning/hold');
  return res.data.data;
}
